import * as localforage from "localforage";
import { getCompanyTokenAPI } from "./getCompanyTokenAPI";
import { phpRequest } from "./phpRequest";

export const createCompanyAPI = async (
  values,
  initCompanyImg,
  defaultImage
) => {
  let formData = new FormData();
  formData.append("name", values.companyName);
  formData.append(
    "parent_company_id",
    values.parentCompany === "-" ? "" : values.parentCompany
  );
  formData.append("country_id", values.companyCountry);
  formData.append("region_id", values.companyRegion);
  formData.append("address", values.companyAddress);
  formData.append("contact_person", values.contactPerson);
  formData.append("inherit_personalize_config", values.inheritPersonalizeConfig);

  if (values.file) {
    formData.append("image", values.file[0]);
    if (initCompanyImg !== defaultImage) {
      // if there is already an old image
      formData.append("old_image", initCompanyImg);
    } else {
      formData.append("old_image", defaultImage);
    }
  }
  formData.append("phone", values.contactPhone);
  formData.append("email", values.contactMail);
  formData.append(
    "fec_customer_id",
    values.customID === "-" ? "" : values.customID
  );
  // formData.append("update_start", values.periodStart.format("HH:mm"));
  // formData.append("update_end", values.periodEnd.format("HH:mm"));
  const data = await phpRequest.post("/company/create", formData);

  getCompanyTokenAPI(data.company.id);

  await localforage.setItem("newCreatedCompanyID", data.company.id);
  await localforage.setItem(data.company.id, data.company);
  await localforage.setItem(`${data.company.id}Name`, data.company.name);
  window.location.replace(`/company-profile/${data.company.id}`);
};
